import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import Error from "./error";
import RevealBtn from './revealBtn';

@inject('igStore')
@observer
class Progress extends Component {
  state = {
    height: 0
  };

  render() {
    const { statsByTeamTexts, statsByTeam, reveal, game, error } = this.props.igStore;
    const { height } = this.state;
    if (error) return <Error/>;
    if (!Object.keys(statsByTeam).length) return null;
    return (
      <Fragment>
        <div className={`ig-item-wrapper${reveal ? ' ig-item-wrapper--open' : ''}`}>
          <div className="ig-progress-wrapper">
            {statsByTeamTexts.map(({ type, text }) => (
              <Item text={text} stat={statsByTeam[type]} sid={game.sid}/>
            ))}
            <ReactResizeDetector handleHeight onResize={(width, height) => this.setState({height})}/>
          </div>
        </div>
        <RevealBtn height={height}/>
      </Fragment>
    );
  }
}

function Item({ text, stat, sid }) {
  const [t1Width, t2Width] = [getWidth(stat, 't1'), getWidth(stat, 't2')];
  return (
    <div className="ig-progress">
      <div className="ig-progress__head">
        <span className="ig-progress__score">{stat.t1}</span>
        <span>{text}</span>
        <span className="ig-progress__score">{stat.t2}</span>
      </div>
      <div className="ig-progress__bar">
        {t1Width ? <div style={{ flexGrow: t1Width }} className={`s-c-${sid}`} /> : ''}
        {t2Width ? <div style={{ flexGrow: t2Width }} className="ig-indicator-t2" /> : ''}
        {!t1Width && !t2Width ? <div /> : ''}
      </div>
    </div>
  );
}

function getWidth(stats, team) {
  if (stats[team] === 0) return 0;
  return (stats[team]/(stats.t1 + stats.t2)) * 100;
}

export default Progress;



// WEBPACK FOOTER //
// ./src/components/ig/progress.js